import { createElement } from 'react';
import { string, node, oneOf, func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import '../chunk-68945c57.js';
import 'lodash/omit';
import '../Button/ActionButtons.js';
import '../Button/index.js';
import Icon from '../Icon/index.js';
import _Tag, { TagContent, RemoveButton } from './styled.js';

var Tag = function Tag(_ref) {
  var children = _ref.children,
      onRemove = _ref.onRemove,
      size = _ref.size,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "onRemove", "size"]);

  return createElement(_Tag, _extends({
    styledSize: size
  }, props), createElement(TagContent, {
    isRemovable: Boolean(onRemove)
  }, children), Boolean(onRemove) && createElement(RemoveButton, {
    onClick: onRemove,
    kind: props.kind === 'outlined' ? 'ghost' : undefined,
    palette: props.palette
  }, createElement(Icon, {
    a11yLabel: "Close",
    icon: "times"
  })));
};
var tagPropTypes = {
  className: string,
  children: node.isRequired,
  kind: oneOf(['outlined']),
  onRemove: func,
  palette: string,
  size: string
};
Tag.propTypes = tagPropTypes;
var tagDefaultProps = {
  className: undefined,
  kind: undefined,
  onRemove: undefined,
  palette: 'text',
  size: 'default'
};
Tag.defaultProps = tagDefaultProps; // @ts-ignore

var C = Tag;

export default C;
export { C as Tag, tagDefaultProps, tagPropTypes };
